import { useState } from "react";
import { X, Tag, Plus } from "lucide-react";
import { TONE_SOFT } from "shared/tones";
import { FORM_CONTROL } from "shared/tableStyles";

interface Props {
  codes: string[];
  onChange: (codes: string[]) => void;
  disabled?: boolean;
}

export default function NaicsCodesInput({ codes, onChange, disabled }: Props) {
  const [input, setInput] = useState("");

  function add() {
    const c = input.trim();
    if (c && !codes.includes(c)) onChange([...codes, c]);
    setInput("");
  }

  function remove(c: string) {
    onChange(codes.filter((x) => x !== c));
  }

  return (
    <div>
      <div className="flex gap-2 mb-2 flex-wrap">
        {codes.map((c) => (
          <span key={c} className={`inline-flex items-center gap-1 rounded-md border px-2 py-0.5 text-xs font-mono ${TONE_SOFT.brand}`}>
            <Tag className="w-3 h-3" />
            {c}
            <button type="button" onClick={() => remove(c)} disabled={disabled} className="ml-0.5 hover:opacity-70 disabled:opacity-40">
              <X className="w-3 h-3" />
            </button>
          </span>
        ))}
      </div>
      <div className="flex gap-2">
        <input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter" || e.key === ",") { e.preventDefault(); add(); } }}
          disabled={disabled}
          placeholder="e.g. 541511 — press Enter"
          className={`flex-1 px-3 py-2 font-mono ${FORM_CONTROL}`}
        />
        <button
          type="button"
          onClick={add}
          disabled={disabled}
          className="px-3 py-2 rounded-lg border border-border bg-surface text-foreground hover:bg-surface-muted text-sm disabled:opacity-40 transition-colors"
        >
          <Plus className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
